import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';

import {
  generateCustomIndexFn,
  RouteTabGroupComponent,
  TabGroupConfig,
} from '@features/tab-group/route-tab-group.component';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, RouteTabGroupComponent],
  selector: 'aux-change-orders',
  templateUrl: './change-orders.component.html',
})
export class ChangeOrdersComponent {
  private readonly launchDarklyService = inject(LaunchDarklyService);

  indexFn = generateCustomIndexFn(
    `${ROUTING_PATH.BUDGET.INDEX}/${ROUTING_PATH.BUDGET.CHANGE_ORDER.INDEX}`
  );
  tabs: TabGroupConfig[] = [
    {
      label: 'Change Orders',
      route: `/${ROUTING_PATH.BUDGET.INDEX}/${ROUTING_PATH.BUDGET.CHANGE_ORDER.INDEX}`,
      show: toObservable(
        this.launchDarklyService.$select((flags) => flags.tab_change_order_review)
      ),
    },
    {
      label: 'Change Log',
      route: ROUTING_PATH.BUDGET.CHANGE_ORDER.CHANGE_LOG,
      show: toObservable(this.launchDarklyService.$select((flags) => flags.tab_budget_changelog)),
    },
    {
      label: 'Compare',
      route: ROUTING_PATH.BUDGET.CHANGE_ORDER.COMPARE,
      show: toObservable(this.launchDarklyService.$select((flags) => flags.tab_compare)),
    },
  ];
}
